<div class="container">
<div class="row" style="justify-content: center">
  <div style="text-align: center">
    <mat-icon svgIcon="new-property-icon"></mat-icon>
    <span>Add a new property</span>
  </div>
</div>

<div style="height: 100%" class="stepper-container">
  <mat-stepper [linear]="true" #stepper>
    <mat-step [stepControl]="rentalProperty">
      <ng-template matStepperIcon="edit">
        <mat-icon class="icon-display">check</mat-icon>
      </ng-template>
      <ng-template matStepLabel>Property</ng-template>
      <div class="container" style="justify-content: center; padding-bottom: 60px;">
        <div class="flex-direction-xs-col">
          <form [formGroup]="rentalProperty">
          <div class="col">

          <div class="form-row">
            <div class="form-col">
              <mat-form-field
                appearance="outline"
              >
                <mat-label style="font-size: 16px !important"
                  >Property street address</mat-label
                >
                <input
                  matInput
                  class="form-outline form-control"
                  placeholder="Property street address"
                  formControlName="propertyStreetAddress"
                  [matAutocomplete]="auto"
                />
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option
                    *ngFor="let suggestion of suggestions"
                    [value]="suggestion.description"
                    (onSelectionChange)="selectPlace(suggestion)"
                  >
                    {{ suggestion.description }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error>Property street address is required</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-col">
              <mat-form-field
                appearance="outline"
              >
                <mat-label style="font-size: 16px !important"
                  >Apt/Unit/Suite</mat-label
                >
                <input
                  matInput
                  formControlName="aptUnitSuite"
                  placeholder="Apt/Unit/Suite"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-col">
              <mat-form-field appearance="outline">
                <mat-label>City</mat-label>
                <input matInput formControlName="city" placeholder="City" />
                <mat-error>City is required</mat-error>
              </mat-form-field>
            </div>
        
            <div class="form-col">
              <mat-form-field
                class="readonly"
                appearance="outline"
              >
                <mat-label>State</mat-label>
        
                <mat-select
                  [disabled]="true"
                  formControlName="state"
                  placeholder="State"
                >
                  @for (state of states; track state) {
                  <mat-option [value]="state.id">{{ state.name }}</mat-option>
                  }
                </mat-select>
                <mat-error>State is required</mat-error>
              </mat-form-field>
            </div>
        
            <div class="form-col">
              <mat-form-field appearance="outline">
                <mat-label>Zip Code</mat-label>
                <input matInput formControlName="zipCode" placeholder="Zip Code" />
                <mat-error
                  *ngIf="this.rentalProperty.get('zipCode')?.errors?.['pattern'] && (rentalProperty.get('zipCode')?.touched)"
                  >Zip Code is invalid</mat-error
                >
        
                <mat-error
                  *ngIf="this.rentalProperty.get('zipCode')?.errors?.['required'] && (rentalProperty.get('zipCode')?.touched)"
                  >Zip Code is required</mat-error
                >
              </mat-form-field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-col">
                <!-- Jurisdiction is assigned by county staff on approval; the taxpayer no longer picks it. -->
            </div>
          </div>
          <div class="form-row">
            <div class="form-col">
              <mat-form-field appearance="outline">
                <mat-label>Started renting</mat-label>
                <input
                  matInput
                  formControlName="startedRenting"
                  [matDatepicker]="picker"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error>Started renting is required</mat-error>
              </mat-form-field>
            </div>
            <div class="form-col">
              <mat-form-field appearance="outline">
                <mat-label>Filing frequency</mat-label>
                <mat-select formControlName="filingFrequency" matNativeControl required>
                  <mat-option value="M">Monthly</mat-option>
                  <mat-option value="Q">Quarterly</mat-option>
                </mat-select>
                <mat-error>Filing frequency is required</mat-error>
              </mat-form-field>
            </div>
          </div>
        
          <div class="form-row" *ngIf="this.isMotelHotel">
            <div class="form-col">
              <mat-form-field
                appearance="outline"
                requiered
              >
                <mat-label style="font-size: 16px !important"
                  >Name on the business sign</mat-label
                >
                <input
                  matInput
                  formControlName="businessName"
                  placeholder="Name on the business sign"
                  required
                />
                <mat-error>Name on the business sign is required</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="form-row" *ngIf="this.isMotelHotel">
            <div class="form-col">
              <mat-form-field
                appearance="outline"
                requiered
              >
                <mat-label style="font-size: 16px !important"
                  >Website url</mat-label
                >
                <input
                  matInput
                  formControlName="webUrl"
                  placeholder="Website url"
                />
                <mat-error>Website url is invalid</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="form-row" *ngIf="this.isIndividualPropertyOwner">
            <div class="form-col">
              <div class="row align-item-center gap-10">
                <mat-checkbox
                  formControlName="usePlatformToRent"
                  color="primary"
                  class="primary"
                >
                  I don't use any platform to rent out my property
                </mat-checkbox>
                <mat-icon
                  aria-hidden="false"
                  matTooltip="In an effort to ensure compliance of all short term/vacation rentals we ask that you provide the rental advertisements and websites that you utilize. Example: airbnb.com/rooms/12345678"
                  >info_outline</mat-icon
                >
              </div>
              <p class="platform-hint"
                 [class.platform-hint--error]="rentalProperty.errors?.['atLeastOneRequired']">
                <span class="req">*</span> Required: check the box above if you don't use a
                platform, or paste your digital platform link below.
              </p>
            </div>
          </div>

          <div class="form-row" *ngIf="this.isIndividualPropertyOwner">
            <div class="form-col">
              <mat-form-field appearance="outline">
                <mat-label>If you use a digital platform, paste link here</mat-label>
                <input
                  matInput
                  formControlName="platFormLink"
                  placeholder="If you use a digital platform, paste link here"
                />
                <mat-error>Platform url is invalid</mat-error>
                <mat-error
                  *ngIf="
                    rentalProperty.errors && rentalProperty.get('platFormLink')?.touched
                  "
                  >You must select the checkbox or paste the digital platform
                  link</mat-error
                >
              </mat-form-field>
            </div>
          </div>
          <div class="form-row" *ngIf="this.isIndividualPropertyOwner">
            <div class="form-col">
              <mat-form-field appearance="outline">
                <mat-label style="font-size: 16px !important"
                  >Rental Property Business Name</mat-label
                >
                <input
                  matInput
                  formControlName="rentalPropertyBusiness"
                  placeholder="Rental Property Business Name"
                  [matAutocomplete]="auto"
                />
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option
                    *ngFor="let suggestion of propertySuggestions"
                    [value]="suggestion.name"
                    (onSelectionChange)="selectProperty(suggestion)"
                  >
                    {{ suggestion.name }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          </div>
        </form>
        </div>
      </div>
 
  

    
    </mat-step>
    <mat-step *ngIf="isIndividualPropertyOwner">
      <ng-template matStepperIcon="edit">
        <mat-icon class="icon-display">check</mat-icon>
      </ng-template>
      <ng-template matStepLabel>Owners</ng-template>
     <app-properties-detail-owners #propertiesDetailOwnersComponent  [dataOwners]="this.owners"></app-properties-detail-owners>
    </mat-step>
    <mat-step [stepControl]="ownerForm" *ngIf="isManagementCompany"  >
      <ng-template matStepperIcon="edit">
        <mat-icon class="icon-display">check</mat-icon>
      </ng-template>
      <ng-template matStepLabel>Owner</ng-template>
      <app-owner-form [countries]="this.countries" [states]="this.states" [ownerForm]="this.ownerForm"></app-owner-form>
    </mat-step>

    <mat-step *ngIf="!isManagementCompany" [stepControl]="rentalPropertyReporting">
      <ng-template matStepperIcon="edit">
        <mat-icon class="icon-display">check</mat-icon>
      </ng-template>
      <ng-template matStepLabel>Reporting</ng-template>
      <div class="form-row">
        <div class="form-col">
          <mat-label class="title-label"
            >Who has the Reporting responsibility for this property ?
          </mat-label>
        </div>
      </div>
      <div class="form-row">
        <div class="form-col">
          <section class="example-section">
            <mat-checkbox
              class="primary"
              [(ngModel)]="isOwner"
              class="example-margin"
              >Owner</mat-checkbox
            >
            <mat-checkbox
              class="primary"
              [(ngModel)]="isManager"
              class="example-margin"
              >Property Management Company</mat-checkbox
            >
          </section>
        </div>
      </div>
      <div class="form-row">
        <div class="form-col">
          <div
            *ngIf="isManager"
            style="max-height: 400px; overflow-y: scroll"
            class="row"
          >
            <div
              class="Frame106"
              style="
                width: 100%;
                height: 100%;
                border-radius: 8px;
                border: 1px #e0e0e0 solid;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                gap: 24px;
                display: inline-flex;
              "
            >
              <div
                class="row"
                style="
                  align-self: stretch;
                  height: 56px;
                  padding-left: 16px;
                  padding-right: 16px;
                  justify-content: flex-end;
                  align-items: flex-end;
                  gap: 8px;
                  display: inline-flex;
                "
              >
                <div
                  class="Frame152"
                  style="
                    flex: 1 1 0;
                    flex-direction: column;
                    justify-content: flex-end;
                    align-items: flex-start;
                    gap: 8px;
                    display: inline-flex;
                  "
                >
                  <div
                    class="Formlabel"
                    style="
                      flex-direction: column;
                      justify-content: flex-start;
                      align-items: flex-start;
                      display: flex;
                    "
                  >
                    <div
                      class="Label"
                      style="
                        color: rgba(0, 0, 0, 0.87);
                        font-size: 16px;
                        font-family: Roboto;
                        font-weight: 400;
                        line-height: 24px;
                        letter-spacing: 0.15px;
                        word-wrap: break-word;
                      "
                    >
                      Add the property management companies here
                    </div>
                  </div>
                </div>

                <button
                  (click)="addCompany()"
                  mat-stroked-button
                  mat-button
                  class="button-stepper-back"
                >
                  ADD COMPANY
                  <mat-icon>add</mat-icon>
                </button>
              </div>
              <div
                class="Frame162149"
                style="
                  align-self: stretch;
                  flex-direction: column;
                  justify-content: flex-start;
                  align-items: flex-start;
                  display: flex;
                "
              >
                <table mat-table [dataSource]="companyDataSource">
                  <!-- ID Column -->
                  <ng-container matColumnDef="name">
                    <th
                      style="background-color: #e3e3e3"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Company name
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.companyName }}
                    </td>
                  </ng-container>

                  <!-- Name Column -->
                  <ng-container matColumnDef="streetAddress">
                    <th
                      style="background-color: #e3e3e3"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Street Address
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.streetAddress }}
                    </td>
                  </ng-container>

                  <!-- Email Column -->
                  <ng-container matColumnDef="aptUnitSuite">
                    <th
                      style="background-color: #e3e3e3"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Apt/unit/suite
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.aptUnitSuite }}
                    </td>
                  </ng-container>

                  <!-- Email Column -->
                  <ng-container matColumnDef="city">
                    <th
                      style="background-color: #e3e3e3"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      City
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.city }}
                    </td>
                  </ng-container>
                  <!-- Email Column -->
                  <ng-container matColumnDef="state">
                    <th
                      style="background-color: #e3e3e3"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      State
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.stateName }}
                    </td>
                  </ng-container>
                  <!-- Email Column -->
                  <ng-container matColumnDef="zipCode">
                    <th
                      style="background-color: #e3e3e3"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Zip Code
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.zipCode }}
                    </td>
                  </ng-container>
                  <!-- Email Column -->
                  <ng-container matColumnDef="action">
                    <th
                      style="background-color: #e3e3e3"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Actions
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      <mat-icon
                        class="icon-pointer"
                        style="color: #2196f3"
                        (click)="editCompany(element)"
                        aria-label="Edit"
                        >edit</mat-icon
                      >
                      <mat-icon
                        (click)="removeCompany(i)"
                        style="color: red"
                        class="icon-pointer"
                        aria-label="Delete"
                        >delete</mat-icon
                      >
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="managementcompaniesColumns"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: managementcompaniesColumns"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-reporting-form
      [rentalPropertyReporting]="this.rentalPropertyReporting"
      #rentalPropertyReportingFormComponent
      [states]="this.states"
    ></app-reporting-form>
    </mat-step>
    <mat-step [stepControl]="rentalPropertyLicense">
      <ng-template matStepperIcon="edit">
        <mat-icon class="icon-display">check</mat-icon>
      </ng-template>
      <ng-template matStepLabel>Licenses</ng-template>
      <div>
        <div *ngIf="!stepCompleted">
          <app-license-form
          [rentalPropertyLicense]="this.rentalPropertyLicense"
          #rentalPropertyLicenseComponent
        ></app-license-form>
        </div>
        <div *ngIf="stepCompleted" class="row">
          <div class="Frame62" style="
              width: 1376px;
              height: 319px;
              padding-top: 56px;
              padding-bottom: 56px;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;
              gap: 32px;
              display: inline-flex;
            ">
            <div class="Frame63" style="
                align-self: stretch;
                height: 106px;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                gap: 24px;
                display: flex;
              ">
              <mat-icon style="
                  color: #2e7d32;
                  font-size: 57px;
                  width: 100px;
                  height: 100px;
                " color="#2E7D32">check_circle_outline</mat-icon>

              <div class="Frame32" style="
                  align-self: stretch;
                  height: 26px;
                  flex-direction: column;
                  justify-content: flex-start;
                  align-items: center;
                  gap: 8px;
                  display: flex;
                ">
                <div class="Formlabel" style="
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    display: flex;
                  ">
                  <div class="Label" style="
                      color: rgba(0, 0, 0, 0.87);
                      font-size: 24px;
                      font-family: Roboto;
                      font-weight: 500;
                      text-transform: uppercase;
                      line-height: 26px;
                      letter-spacing: 0.46px;
                      word-wrap: break-word;
                    ">
                    Property submitted succesfully!
                  </div>
                </div>
              </div>
            </div>
            <div class="Frame33" style="
                height: 69px;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                gap: 8px;
                display: flex;
              ">
              <div class="Formlabel" style="
                  height: 69px;
                  flex-direction: column;
                  justify-content: flex-start;
                  align-items: flex-start;
                  display: flex;
                ">
                <div class="Label" style="
                    align-self: stretch;
                    text-align: center;
                    color: rgba(0, 0, 0, 0.87);
                    font-size: 16px;
                    font-family: Roboto;
                    font-weight: 400;
                    line-height: 22.88px;
                    letter-spacing: 0.17px;
                    word-wrap: break-word;
                  ">
                  Your information has been submitted and is now being reviewed.
                  We'll get back to you within 72 hours. Sit tight and we'll be
                  in touch soon!<br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
</div>
<div *ngIf="!stepCompleted" style="width: 100%;background-color: #f5f5f5;position: fixed;bottom: 0;background: #f5f5f5;left: auto;z-index: 1;">
  <div *ngIf="!stepCompleted" class="button-stepper-footer-detail05">
    <button mat-stroked-button mat-button (click)="cancelClick()" class="button-stepper-cancel">
      CANCEL<mat-icon>close</mat-icon>
    </button>
    <button (click)="goBack(stepper)" *ngIf="stepper.selectedIndex > 0" mat-stroked-button mat-button
      class="button-stepper-back">
      BACK
      <mat-icon>arrow_left_alt</mat-icon>
    </button>
    <button
      [disabled]="!rentalProperty.valid"
      [ngClass]="{
        'button-stepper-allow': rentalProperty.valid,
        'button-stepper': rentalProperty.invalid
      }"
      *ngIf="stepper.selectedIndex == 0"
      mat-stroked-button
      mat-button
      (click)="goForward(stepper)"
      class="button-stepper-allow"
    >
      NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
    </button>
    <button class="button-stepper-allow" *ngIf="stepper.selectedIndex == 1 && isIndividualPropertyOwner" mat-stroked-button mat-button
      (click)="goForward(stepper)" class="button-stepper-allow">
      NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
    </button>

    <button
      [disabled]="!ownerForm.valid"
      [ngClass]="{
        'button-stepper-allow': ownerForm.valid,
        'button-stepper': ownerForm.invalid
      }"
      *ngIf="stepper.selectedIndex == 1 && isManagementCompany"
      mat-stroked-button
      mat-button
      (click)="goForward(stepper)"
      class="button-stepper-allow"
    >
      NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
    </button>
    <button
    [disabled]="!rentalPropertyReporting.valid"
    [ngClass]="{
      'button-stepper-allow': rentalPropertyReporting.valid,
      'button-stepper': rentalPropertyReporting.invalid
    }"
    *ngIf="stepper.selectedIndex == 1 && isMotelHotel"
    mat-stroked-button
    mat-button
    (click)="goForward(stepper)"
    class="button-stepper-allow"
  >
    NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
  </button>
    <button
    [disabled]="!rentalPropertyReporting.valid || (!isOwner && !isManager)"
    [ngClass]="{
      'button-stepper-allow': rentalPropertyReporting.valid && (isOwner || isManager),
      'button-stepper': rentalPropertyReporting.invalid || (!isOwner && !isManager)
    }"
    *ngIf="stepper.selectedIndex == 2 && isIndividualPropertyOwner"
    mat-stroked-button
    mat-button
    (click)="goForward(stepper)"
    class="button-stepper-allow"
  >
    NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
  </button>
    <button
    [ngClass]="{
      'button-stepper-allow': rentalPropertyLicense.valid,
      'button-stepper': rentalPropertyLicense.invalid
    }"
    *ngIf="stepper.selectedIndex == 2 && !isIndividualPropertyOwner"
    mat-stroked-button
    mat-button
    (click)="save()"
    class="button-stepper-allow"
  >
  SUBMIT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
  </button>

  <button
  [ngClass]="{
    'button-stepper-allow': rentalPropertyLicense.valid,
    'button-stepper': rentalPropertyLicense.invalid
  }"
  *ngIf="stepper.selectedIndex == 3"
  mat-stroked-button
  mat-button
  (click)="save()"
  class="button-stepper-allow"
>
SUBMIT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
</button>
 
  </div>
</div>
</div>

